// STORE DEPENDANCY
import { Action } from '@ngrx/store';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';

export enum ActionTypes {
  // MASTER NOTIFICATION ACTIONS
  NOTIFICATION_COMMON = '[Notification] Notification Common',
  NOTIFICATION_COMMON_SUCCESS = '[Notification] Notification Common Success',
}

// -------------------------------
//  Notification Common
// -------------------------------
export class NotificationCommonAction implements Action {
  readonly type = ActionTypes.NOTIFICATION_COMMON;
  constructor(public payload: ApiPayload) { }
}

// -------------------------------
//  Notification Common Success
// -------------------------------
export class NotificationCommonSuccessAction implements Action {
  readonly type = ActionTypes.NOTIFICATION_COMMON_SUCCESS;
  constructor(public response?: any) { }
}

export type Actions =
  | NotificationCommonAction
  | NotificationCommonSuccessAction;
